import React from 'react';
import { useUpdate } from '../../context/UpdateContext';
import { Snackbar, Button } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import { debugLog } from '../../utils/debugLog';

export default function UpdateNotification() {
    const { updateAvailable, performUpdate } = useUpdate();
    debugLog('updateAvailable', updateAvailable)
    return (
        <Snackbar
            open={updateAvailable}
            message="A new version is available"
            action={
                <Button
                    color="secondary"
                    size="small"
                    onClick={performUpdate}
                    startIcon={<UpdateIcon />}
                >
                    Update
                </Button>
            }
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        />
    );
} 